import {LOAD_HIC_COMPLETE, LOAD_HIC_ERROR, LOAD_HIC_START, LOAD_HIC_SUCCESS} from './actions';
import {createResourceReducer} from 'src/shared/utils/resource';

export const hic = createResourceReducer({
  start: LOAD_HIC_START,
  success: LOAD_HIC_SUCCESS,
  error: LOAD_HIC_ERROR,
  complete: LOAD_HIC_COMPLETE,
});
